/* eslint-disable import/no-anonymous-default-export */
import { Descriptions } from "antd";
import styled from "styled-components";

const ContainerKeyboardInfo = styled.div`
margin-top: 0.5rem;
`;


export default () => {

    return (<ContainerKeyboardInfo>
        <Descriptions labelStyle={{ color: 'var(--primary-color)' }} size="small" layout="vertical" style={{ 'fontSize': 10 }} bordered={true} title="Atajos de teclado">
            <Descriptions.Item labelStyle={{ 'fontWeight': 'bold' }} label="Verificar">F11</Descriptions.Item>
            <Descriptions.Item labelStyle={{ 'fontWeight': 'bold' }} label="Descartar">F12</Descriptions.Item>
            <Descriptions.Item labelStyle={{ 'fontWeight': 'bold' }} label="Consulta local">F8</Descriptions.Item>
        </Descriptions>
    </ContainerKeyboardInfo>);
}